
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
class UnlockBox extends Vue {
  @Prop({ default: null }) readonly slug!: string;
  @Prop({ default: null }) readonly gameUid!: string;
  @Prop({ default: null }) readonly type!: string;

  cancel(): void {
    this.$bvModal.hide("team-modal-unlock");
  }
  unlock(): void {
    if (this.type == "gameType") {
      this.$store.dispatch("gameStore/addEditLock", {
        slug: this.slug,
        value: false,
      });
    }
    if (this.type == "city") {
      this.$store.dispatch("cityStore/addEditLock", {
        slug: this.slug,
        value: false,
      });
    }
    if (this.type == "game") {
      this.$store.dispatch("gameStore/addGameEditLock", {
        slug: this.slug,
        value: false,
      });
    }

    this.$bvModal.hide("team-modal-unlock");
  }
}

export default UnlockBox;
